import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../../redux/actions';
import {RUNNING, SUCSSES, ERROR} from '../../redux/actions';

const LOGIN_PROCESS = "LOGIN_PROCESS"

export class Login extends Component {
  state = {
    username: '',
    email: '',
    password: '',
  };

  static propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.login(this.state.username,
                      this.state.email,
                      this.state.password, LOGIN_PROCESS);
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    /* if user is logged-in take to home */
    if (this.props.isAuthenticated) {
      return <Redirect to="/home" />;
    }
    const { username, email, password } = this.state;
    return (
      <div className="row login-fragment border py-5 ">
        <div className="col-md-6 m-auto">
          <div className="card card-body mt-5">
            <h2 className="text-center page-title">Login</h2>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>Username</label>
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  onChange={this.onChange}
                  value={username}
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  onChange={this.onChange}
                  value={email}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  onChange={this.onChange}
                  value={password}
                />
              </div>
              <div className="form-group">
                {this.props.loginProcessState === ERROR &&
                  <ul className="errorList">
                      <li>
                        {"there was an error with given credentials"}
                      </li>
                  </ul>
                }
                {this.props.loginProcessState === RUNNING &&
                  <div class="spinner-border text-dark" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                }
                <div>
                  <button disabled={this.props.loginProcessState === RUNNING} type="submit" className="btn btn-primary">
                    Login
                  </button>
                </div>
              </div>
              <p>
                Don't have an account? <Link to="/register">Register</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const actionsCreators = {
  login: login
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginProcessState: state.processManager.processes[LOGIN_PROCESS]
});

export default connect(mapStateToProps,actionsCreators)(Login);
